import { render, staticRenderFns } from "./MigrateMemberList.vue?vue&type=template&id=1a27fbda&"
import script from "./MigrateMemberList.vue?vue&type=script&lang=js&"
export * from "./MigrateMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports